var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"related_profiles"},[_c('h2',[_vm._v("Related Profiles")]),(_vm.related)?_c('div',{staticClass:"comments owl-wrapper"},[_c('Carousel',{attrs:{"responsive":{0:{items:1,nav:false,dots:false},600:{items:1.8,nav:false,dots:true,loop:false,margin:10},
        1200:{items:3,nav:false,dots:true,loop:false,margin:10}
        }}},_vm._l((_vm.related),function(rel,index){return _c('RelatedSingle',{key:index,attrs:{"profile":rel}})}),1)],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }